import {ELinkType} from 'src/hooks';

// при смене наименований подсказка снова отобразится в ЛК, если ее удаляли
// см. src/containers/User/api.ts setUserConfig
export enum EAdviceType {
  WA_QUALITY_CHANNELS = 'WA_QUALITY_CHANNELS',
  WA_QUALITY_CHANNEL = 'WA_QUALITY_CHANNEL',
  WA_QUALITY_BROADCAST_SETTINGS = 'WA_QUALITY_BROADCAST_SETTINGS',
  WA_QUALITY_BROADCAST_AUDIENCE = 'WA_QUALITY_BROADCAST_AUDIENCE',
  WA_QUALITY_TEMPLATE_TEXT = 'WA_QUALITY_TEMPLATE_TEXT',
  WA_QUALITY_TEMPLATE_BUTTONS = 'WA_QUALITY_TEMPLATE_BUTTONS',
  WA_CHANNEL_VERIFICATION = 'WA_CHANNEL_VERIFICATION',
  MAX_BLOCKING_PROTECTION = 'MAX_BLOCKING_PROTECTION',
}

export enum EPointsIcon {
  NUMBER = 'NUMBER',
  CHECKMARK = 'CHECKMARK',
}

export type TAdviceType = keyof typeof EAdviceType;
export type TPointsIcon = keyof typeof EPointsIcon;

export const moreLinkHash: Record<TAdviceType, ELinkType> = {
  [EAdviceType.WA_QUALITY_CHANNELS]: ELinkType.CHANNEL_QUALITY_WA,
  [EAdviceType.WA_QUALITY_CHANNEL]: ELinkType.CHANNEL_QUALITY_WA,
  [EAdviceType.WA_QUALITY_BROADCAST_SETTINGS]: ELinkType.WABA_BLOCK,
  [EAdviceType.WA_QUALITY_BROADCAST_AUDIENCE]: ELinkType.WABA_BLOCK,
  [EAdviceType.WA_QUALITY_TEMPLATE_TEXT]: ELinkType.WABA_BLOCK,
  [EAdviceType.WA_QUALITY_TEMPLATE_BUTTONS]: ELinkType.WABA_BLOCK,
  [EAdviceType.WA_CHANNEL_VERIFICATION]: ELinkType.WA_CHANNEL_VERIFICATION,
  [EAdviceType.MAX_BLOCKING_PROTECTION]: ELinkType.MAX_BLOCKING_PROTECTION,
};
